<template>
    <div>
      <div
        class="sidenav-overlay"
        v-if="isOpen"
        @click="$emit('close')"
      ></div>
      <div :class="['sidenav', { open: isOpen }]" class="">
        <div class="header-container mt-1">
          <div class="brand-info" :class="isExclusive ? 'brand-info-exclusives' : ''">
            <div class="brand-icon d-flex align-items-center">
              <div class="brand-logo">
                <img v-if="isExclusive" src="./assets/images/tssgif.gif" alt="Logo" />
                <img v-else src="./assets/images/non-member-logo2.gif" alt="Logo"/>
              </div>
              <div class="user-info">
                <!-- <div class="location-icon" :class="!authStatus ? 'ml-4' : ''">
                  <LocationChange :isSideNav="true"/>
                </div> -->
                <!-- Currenty Disable for Improvement -->
                <div v-if="authStatus" class="user">
                  <h6 @click="redirectToMyAcc" class="user-name">{{user.firstname}} {{ user.lastname }} <img src="https://tss-static-images.gumlet.io/right-arrow.svg" style="width: 20px;" alt="" :style="isExclusive ? 'filter: invert(100%) brightness(90%);' : 'filter: invert(60%) brightness(80%);'"></h6>
                  <router-link to="/membership" class="member-link">
                    <div v-if="isExclusive">
                      <p class="user-exclusive-member">YOU ARE A MEMBER</p>
                      <p class="exclusive-description">Total Member Saving Till Now: <span> {{ currencySymbol }}{{ exclusiveDetails && exclusiveDetails.exclusive_savings || 0 }}</span> </p>
                    </div>
                    <div v-else>
                      <p class="non-exclusive-member">BECOME A MEMBER</p>
                      <p style="color: black;" class="exclusive-description">Get Lowest Prices on All Products & More</p>
                    </div>
                  </router-link>
                  <!-- <p class="user-email">{{user.email}}</p> -->
                </div>
                <div v-else class="login-block" @click="redirectToLogin">
                  <span>Log in/Register</span>
                </div>
              </div>
            </div>
            <div>
            </div>
          </div>
          <div class="notify-user">
            <span>
              <template v-if="authStatus">
                <template v-if="user && user.tss_points && user.tss_points > 100">
                  Use Your <span class='tss-highlight'>{{ parseInt(user.tss_points) }} </span>TSS Points On Your Next Order
                  <img class="ml-1"
                      style="width: 13.8px; height: 13.8px; cursor: pointer; margin-top: -1px"
                      @click="setTSSPointsData"
                      src="https://tss-static-images.gumlet.io/icons/tssHelpDetails.png"
                      alt="More Info">
                </template>
                <template v-else>
                  Earn 10% Cashback on Every App Order

                  <span v-if="isDesktop" class="my-1">
                    <a href="https://play.google.com/store/apps/details?id=com.thesouledstore" target="_blank">
                      <img class="store-icon" src="https://tss-static-images.gumlet.io/google-play-store-new.png" alt="More Info">
                    </a>
                    <a href="https://apps.apple.com/in/app/the-souled-store/id1493897434" target="_blank">
                      <img class="store-icon" src="https://tss-static-images.gumlet.io/appstore.png" alt="More Info">
                    </a>
                  </span>
                </template>
              </template>

              <template v-else>
                Earn 10% Cashback on Every App Order

                <span v-if="isDesktop" class="my-1">
                  <a href="https://play.google.com/store/apps/details?id=com.thesouledstore" target="_blank">
                    <img class="store-icon" src="https://tss-static-images.gumlet.io/google-play-store-new.png" alt="More Info">
                  </a>
                  <a href="https://apps.apple.com/in/app/the-souled-store/id1493897434" target="_blank">
                    <img class="store-icon" src="https://tss-static-images.gumlet.io/appstore.png" alt="More Info">
                  </a>
                </span>
              </template>
            </span>

          </div>
          <tssHelpDetails v-if="isHelp" :setPopup="helpDetails" :processData="processData" :isSidenavOpen="true"/>
          <div class="nav-menu-container">
            <div class="nav-menu-list mb-3 d-flex" v-for="(item, sideNavIndex) in sideNavData" :key="sideNavIndex">
              <div class="nav-menu-item" @click="selectNavMenu(item)">
                <span :class="[activeNav === item.name.toLowerCase() ? 'activeCat':'']">{{ item.name.toUpperCase()  }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="list-container">
         <div v-if="sideNavCategoryData && sideNavCategoryData.cat_list && sideNavCategoryData.cat_list.length && sideNavCategoryData.cat_list.length > 0">
           <div class="item-list category-dropdown pb-2"  v-for="(item, catListIndex) in sideNavCategoryData.cat_list" :key="catListIndex">
            <div class="list-crousel mt-2" v-if="item.is_crousel">
              <div class="list-crousel-item" v-if="item.category && item.category.length && item.category.length > 0">
                <carousel ref="my-carousel" :key="activeNav" :navigationEnabled="false"
                  :paginationEnabled="true" navigationNextLabel=" " navigationPrevLabel=" "
                  :autoplay="false" :loop="true" :speed="500" :class="isDesktop ? 'bannerview' : 'mobileBannerView'" :perPage="isDesktop ? 5 : 3.6"
                  :scrollPerPage="true"
                  :perPageCustom="[[292, 3], [350, 3], [410, 3.5], [480, 4], [768, 3.7], [1200, 4.7], [1920, 5]]"
                  :mouse-drag="true"
                  :paginationPadding="isDesktop ? 3 : 2" :paginationSize="6" :paginationPosition="'bottom'"
                  >
                    <slide class="" v-for="(bannerImage, catogeryIndex) in item.category" :key="catogeryIndex">
                      <div class="carousel-block mx-2">
                        <router-link
                            :to="bannerImage.url_key || '/'"
                            class="d-inline-block w-100"
                        >
                            <div class="icon-wrapper">
                              <span v-if="bannerImage.has_tag && bannerImage.tag_name" style="top: 0;" class="large-icon-tag" :style="{ backgroundColor: bannerImage.custom_text_color || '' }">{{bannerImage.tag_name}}</span>
                              <img style="width: 100px;" :data-src="bannerImage.menu_icon_image" :alt="''" class="img-auto carousel-img" width="351" height="351" @error="retryImageLoad($event, bannerImage.menu_icon_image)"/>
                            </div>
                            <div class="carousel-text">
                              <span>{{ bannerImage.name }}</span>
                            </div>
                        </router-link>
                      </div>
                    </slide>
                </carousel>
              </div>
            </div>
            <div class="category-container mt-2" v-else>
              <div class="cat-list nav-item" v-if="(isDesktop && item.is_active_web) || (!isDesktop && item.is_active_mobile)">
                <div class="cat-list-dropdown" v-if="!item.web_dropdown">
                  <router-link :to="item.url_key || '/'" class="d-block w-100">
                    <span :style="item.udf_1 ? { color: item.udf_1 || '' } : {}">{{ item.name }}</span>
                    <small v-if="item.has_tag && item.tag_name" class="singal-tag-name mb-30" :style="{ color: item.custom_text_color || '' }">{{item.tag_name}}</small>
                  </router-link>
                </div>
                <div v-else
                  class="cat-list-toggle cat-list-dropdown d-flex justify-content-between align-items-center"
                  :id="'catListMenuLink1' + catListIndex"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#collapseCategory' + catListIndex"
                  role="button"
                  aria-expanded="false"
                  :aria-controls="'collapseCategory' + catListIndex"
                  @click="item.is_dropdown_open = !item.is_dropdown_open"
                >
                  <span class="heading-wraper" :style="item.udf_1 ? { color: item.udf_1 || '' } : {}">
                    <small v-if="item.has_tag && item.tag_name" class="tag-name mb-30" :style="{ color: item.custom_text_color || '' }">{{item.tag_name}}</small>
                    {{ item.name }}</span>
                  <img class="arrowImg ms-2" :class="item.is_dropdown_open ? 'arrow-up' : ''" src="https://tss-static-images.gumlet.io/right-arrow.svg" alt="Arrow">
                </div>
                
                <div 
                  class="collapse category-list"
                  :id="'collapseCategory' + catListIndex"
                  :class="{ show: item.is_dropdown_open }"
                >
                  <div v-if="item.category && item.category.length && item.category.length > 0" class="category-conatiner">
                    <div class="catogery-list" :class="isDesktop ? 'ml-2' : ''" v-for="(cat, catIndex) in item.category" :key="catIndex">
                      <div class="padding-py3" :class="catIndex < item.category.length - 1 ? 'category-dropdown' : ''">
                        <div class="cat-dropdown" v-if="!cat.web_dropdown">
                          <router-link class="d-block text-decoration-none hover-tag-name" :to="cat.url_key || '/'" >
                              <span class="heading-wraper"  style="width: 100%;"
                              :style="{
                                ...(cat.udf_1 ? { color: cat.udf_1 } : {}),
                                ...(cat.udf_2 ? { fontWeight: cat.udf_2 } : {})
                              }"> 
                                <small v-if="cat.has_tag && cat.tag_name" class="tag-name mb-30" :style="{ color: cat.custom_text_color || '' }">{{item.tag_name}}</small>
                                {{ cat.name }}
                              </span>
                          </router-link>
                        </div>
                        <div v-else
                          class="cat-toggle cat-dropdown d-flex justify-content-between align-items-center"
                          data-bs-toggle="collapse"
                          :data-bs-target="'#collapseCategoryList' + catIndex"
                          role="button"
                          :aria-expanded="cat.is_dropdown_open ? 'true' : 'false'"
                          :aria-controls="'collapseCategoryList' + catIndex"
                          @click="cat.is_dropdown_open = !cat.is_dropdown_open"
                        >
                          <span class="heading-wraper"
                          :style="{
                            ...(cat.udf_1 ? { color: cat.udf_1 } : {}),
                            ...(cat.udf_2 ? { fontWeight: cat.udf_2 } : {})
                          }"> 
                            <small v-if="cat.has_tag && cat.tag_name" class="tag-name mb-30" :style="{ color: cat.custom_text_color || '' }">{{cat.tag_name}}</small>
                            {{ cat.name }}
                          </span>
                          <!-- <span>{{ cat.name }}</span> -->
                          <img 
                            class="arrowImg img-fade ms-2 mr-2" 
                            :class="cat.is_dropdown_open ? 'arrow-up' : ''" 
                            src="https://tss-static-images.gumlet.io/right-arrow.svg" 
                            alt="Arrow"
                          >
                        </div>

                        <div 
                          class="collapse category-list"
                          :id="'collapseCategoryList' + catListIndex"
                          :class="{ show: cat.is_dropdown_open }"
                        >
                        <div class="sub-category-conatiner mt-2">
                          <div class="sub-category-list" :class="{ 'has-small-icon': cat.sub_category.some(subCat => !subCat.is_large_icon) }">
                            <div v-for="(subCat, subCatIndex) in cat.sub_category" :key="subCatIndex" class="cat-icon-continer">
                              <router-link :to="subCat.url_key || '/'" class="sub-cat-icon" :class="subCat.is_large_icon ? 'sub-cat-large-icon' : ''">
                                <div class="icon-wrapper">
                                  <span v-if="subCat.has_tag && subCat.tag_name" class="large-icon-tag" :class="subCat.is_large_icon ? '' : 'small-icon-tag'" :style="{ backgroundColor: subCat.custom_text_color || '' }">{{subCat.tag_name}}</span>
                                  <img v-if="subCat.menu_icon_image" :data-src="subCat.menu_icon_image" alt="icon" @error="retryImageLoad($event, subCat.menu_icon_image)">
                                  <img v-else src="https://tss-static-images.gumlet.io/pdpmobile.png" alt="icon">
                                </div>
                                <div class="sub-cat-name" :class="subCat.is_large_icon ? '' : 'sub-cat-name-w'">
                                  <span>{{ subCat.name }}</span>
                                </div>
                              </router-link>

                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
         </div>

          <!-- Common for all -->
          <div class="item-list category-dropdown pb-2" v-if="sideNavCommonData && sideNavCommonData.length && sideNavCommonData.length > 0" v-for="(item, commonCatListIndex) in sideNavCommonData" :key="commonCatListIndex">
            <div class="category-container mt-2">
              <div class="cat-list nav-item" v-if="(isDesktop && item.is_active_web) || (!isDesktop && item.is_active_mobile)">
                <div class="cat-list-dropdown" v-if="!item.web_dropdown">
                  <router-link
                    :to="item.url_key || '/'" class="d-block w-100"
                    >
                    <span :style="item.udf_1 ? { color: item.udf_1 || '' } : {}">{{ item.name }}</span>
                    <small v-if="item.has_tag && item.tag_name" class="singal-tag-name mb-30" :style="{ color: item.custom_text_color || '' }">{{item.tag_name}}</small>
                  </router-link>
                </div>
                <div v-else
                  class="cat-list-toggle cat-list-dropdown d-flex justify-content-between align-items-center"
                  :id="'catListMenuLink1' + commonCatListIndex"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#collapseCategory' + commonCatListIndex"
                  role="button"
                  aria-expanded="false"
                  :aria-controls="'collapseCategory' + commonCatListIndex"
                  @click="item.is_dropdown_open = !item.is_dropdown_open"
                >
                  <span class="heading-wraper" :style="item.udf_1 ? { color: item.udf_1 || '' } : {}">
                    <small v-if="item.has_tag && item.tag_name" class="tag-name mb-30" :style="{ color: item.custom_text_color || '' }">{{item.tag_name}}</small>
                    {{ item.name }}</span>
                  <img class="arrowImg ms-2" :class="item.is_dropdown_open ? 'arrow-up' : ''" src="https://tss-static-images.gumlet.io/right-arrow.svg" alt="Arrow">
                </div>
                
                <div 
                  class="collapse category-list"
                  :id="'collapseCategory' + commonCatListIndex"
                  :class="{ show: item.is_dropdown_open }"
                >
                  <div v-if="item.category && item.category.length && item.category.length > 0" class="category-conatiner">
                    <div class="catogery-list" :class="isDesktop ? 'ml-2' : ''" v-for="(cat, catIndex) in item.category" :key="catIndex">
                      <div class="padding-py3" :class="catIndex < item.category.length - 1 ? 'category-dropdown' : ''">
                        <div class="cat-dropdown" v-if="!cat.web_dropdown">
                          <router-link class="d-block text-decoration-none hover-tag-name" :to="cat.url_key || '/'">
                            <span class="heading-wraper"
                            :style="{
                                ...(cat.udf_1 ? { color: cat.udf_1 } : {}),
                                ...(cat.udf_2 ? { fontWeight: cat.udf_2 } : {})
                              }"> 
                            <small v-if="cat.has_tag && cat.tag_name" class="tag-name mb-30" :style="{ color: cat.custom_text_color || '' }">{{item.tag_name}}</small>
                            {{ cat.name }}
                          </span>
                          </router-link>
                        </div>
                        <div v-else
                          class="cat-toggle cat-dropdown d-flex justify-content-between align-items-center"
                          data-bs-toggle="collapse"
                          :data-bs-target="'#collapseCategoryList' + catIndex"
                          role="button"
                          :aria-expanded="cat.is_dropdown_open ? 'true' : 'false'"
                          :aria-controls="'collapseCategoryList' + catIndex"
                          @click="cat.is_dropdown_open = !cat.is_dropdown_open"
                        >
                          <span class="heading-wraper"
                          :style="{
                              ...(cat.udf_1 ? { color: cat.udf_1 } : {}),
                              ...(cat.udf_2 ? { fontWeight: cat.udf_2 } : {})
                            }">  
                            <small v-if="cat.has_tag && cat.tag_name" class="tag-name mb-30" :style="{ color: cat.custom_text_color || '' }">{{item.tag_name}}</small>
                            {{ cat.name }}
                          </span>
                          <!-- <span>{{ cat.name }}</span> -->
                          <img 
                            class="arrowImg img-fade ms-2 mr-2" 
                            :class="cat.is_dropdown_open ? 'arrow-up' : ''" 
                            src="https://tss-static-images.gumlet.io/right-arrow.svg" 
                            alt="Arrow"
                          >
                        </div>

                        <div 
                          class="collapse category-list"
                          :id="'collapseCategoryList' + commonCatListIndex"
                          :class="{ show: cat.is_dropdown_open }"
                        >
                        <div class="sub-category-conatiner mt-2">
                          <div class="sub-category-list" :class="{ 'has-small-icon': cat.sub_category.some(subCat => !subCat.is_large_icon) }">
                            <div v-for="(subCat, subCatIndex) in cat.sub_category" :key="subCatIndex" class="cat-icon-continer" >
                              <router-link :to="subCat.url_key || '/'" class="sub-cat-icon" :class="subCat.is_large_icon ? 'sub-cat-large-icon' : ''">
                                <div class="icon-wrapper">
                                  <span v-if="subCat.has_tag && subCat.tag_name" class="large-icon-tag" :class="subCat.is_large_icon ? '' : 'small-icon-tag'" :style="{ backgroundColor: subCat.custom_text_color || '' }">{{subCat.tag_name}}</span>
                                  <img v-if="subCat.menu_icon_image" :data-src="subCat.menu_icon_image" alt="icon">
                                  <img v-else src="https://tss-static-images.gumlet.io/pdpmobile.png" alt="icon">
                                </div>
                                <div class="sub-cat-name" :class="subCat.is_large_icon ? '' : 'sub-cat-name-w'">
                                  <span>{{ subCat.name }}</span>
                                </div>
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- More Static Code -->
          <!-- <div class="item-list category-dropdown pb-2">
            <div class="category-container mt-2">
              <div class="cat-list nav-item">
                <div
                  class="cat-list-toggle cat-list-dropdown d-flex justify-content-between align-items-center"
                  id="catListMenuLinkMore"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseCategoryMore"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseCategoryMore"
                  @click="isMoreDropdownOpen = !isMoreDropdownOpen"
                >
                  <span>More</span>
                  <img
                    class="arrowImg ms-2"
                    :class="{ 'arrow-up': isMoreDropdownOpen }"
                    src="https://tss-static-images.gumlet.io/right-arrow.svg"
                    alt="Arrow"
                  />
                </div>
                <div
                  class="collapse category-list"
                  id="collapseCategoryMore"
                  :class="{ show: isMoreDropdownOpen }"
                >
                  <div class="category-container">
                    <div class="category-list" :class="{ 'ml-2': isDesktop }">
                      <router-link to="/stores-near-me">
                        <div class="py-3 category-dropdown">
                          <div class="cat-dropdown">
                            <span>Store near me</span>
                          </div>
                        </div>
                      </router-link>
                    </div>
                    <div class="category-list" :class="{ 'ml-2': isDesktop }">
                      <router-link to="/about-us">
                        <div class="py-3 category-dropdown">
                          <div class="cat-dropdown">
                            <span>About us</span>
                          </div>
                        </div>
                      </router-link>
                    </div>
                    <div class="category-list" :class="{ 'ml-2': isDesktop }">
                      <router-link to="/from-the-soul">
                        <div class="py-3 category-dropdown">
                          <div class="cat-dropdown">
                            <span>Community Initiatives</span>
                          </div>
                        </div>
                      </router-link>
                    </div>
                    <div class="category-list" :class="{ 'ml-2': isDesktop }">
                      <router-link to="/careers">
                        <div class="py-3">
                          <div class="cat-dropdown">
                            <span>Carers</span>
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
    </div>
    </div>
  </template>
  
  <script>
  const $ = require('jquery')
  window.jQuery = $
  import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import LocationChange from './components/common/LocationChange.vue'
  import {Carousel, Slide} from 'vue-carousel'
  import carouselSlider from './components/common/carouselSlider.vue'
  import tssHelpDetails from './components/common/tssHelpDetails.vue'
  export default {
    name: 'SideNav',
    components: {
      LocationChange,
      carouselSlider,
      Carousel,
      Slide,
      tssHelpDetails
    },
    props: {
      isOpen: {
        type: Boolean,
        default: false
      },
      isDesktop: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        activeNav: this.webcategory,
        isMoreDropdownOpen: false,
        processDataTSSPoints: [
          'TSS POINTS',
          'You can use 10% of your total points for every order'
        ],
        processData: [],
        isHelp: false
      }
    },
    watch: {
      // activeWebCategory (newVal) {
      //   if (this.isDesktop) {
      //     this.activeNav = newVal
      //     let activeNavData = this.sideNavData.find(item => item.url_key === this.$route.path)
      //     this.selectNavMenu(activeNavData)
      //   }
      // },
      webcategory (newVal) {
        this.activeNav = newVal
        let activeNavData = this.sideNavData.find(item => item.name.toLowerCase() === newVal || item.url_key === this.$route.path)
        this.selectNavMenu(activeNavData)
      },
      '$route.fullPath' (newVal, oldVal) {
        if (newVal !== oldVal && this.isOpen) {
          let activeNavData = this.navMenus.find(item => item.name.toLowerCase() === this.activeNav)
          const activeGenderType = activeNavData.url.replace(/^\/+/, '')
          if (activeNavData && activeGenderType) {
            this.$store.commit('WEBCATEGORY', activeGenderType)
            Vue.ls.set('tss_landingCategory', activeGenderType)
          }
          this.$store.commit('GTAG_EVENT', {eventName: 'NAVIGATE_FROM_SIDE_NAV',
            payload: {
              Url: newVal,
              User_ID: this.user.user_id || 'NA',
              Platform: 'WEB'
            }
          })
          this.$emit('close')
        }
      },
      isOpen (newVal) {
        if (newVal) {
          document.body.style.overflow = 'hidden' // freeze scroll
        } else {
          document.body.style.overflow = '' // restore scroll
        }
      },
      sideNavData (newVal) {
        if (newVal) {
          let activeNavData = newVal.find(item => item.name.toLowerCase() === this.activeNav || item.url_key === this.$route.path || item.url_key === `/${this.activeNav}`)
          if (activeNavData) {
            this.selectNavMenu(activeNavData)
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        webcategory: 'webcategory',
        isSelectedCountryIndia: 'isSelectedCountryIndia',
        isExclusive: 'isExclusive',
        user: 'user',
        authStatus: 'authStatus',
        sideNavData: 'sideNavData',
        sideNavCategoryData: 'sideNavCategoryData',
        activeWebCategory: 'activeWebCategory',
        sideNavCommonData: 'sideNavCommonData',
        exclusiveDetails: 'exclusiveDetails',
        currencySymbol: 'currencySymbol',
        navMenus: 'navMenus',
        calculations: 'calculations'
      })
    },
    mounted () {
      let gender = Vue.ls.get('tss_landingCategory')
      this.activeNav = gender
      let activeNavData = this.sideNavData.find(item => item.name.toLowerCase() === gender || item.url_key === this.$route.path || item.url_key === `/${gender}`)
      this.selectNavMenu(activeNavData)
    },
    methods: {
      selectNavMenu (item) {
        this.$store.commit('SET_SIDENAV_CATEGORY_DATA', [])
        this.activeNav = item && item.name && item.name.toLowerCase() || ''
        this.$store.commit('SET_SIDENAV_CATEGORY_DATA', item)
      },
      redirectToMyAcc () {
        this.$router.push(this.isDesktop ? '/orders' : '/my-account')
        this.$emit('close')
      },
      redirectToLogin () {
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'HEADER_PROFILE', payload: {}})
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
        this.$emit('close')
      },
      helpDetails () {
        this.isHelp = !this.isHelp
      },
      setTSSPointsData () {
        this.processDataTSSPoints[1] = `You can pay a maximum ${this.calculations.tss_points_discount || 10}% of your cart value as TSS points.`
        this.processData = this.processDataTSSPoints
        this.isHelp = true
      },
      retryImageLoad (event, iconImageLink) {
        const imgEl = event.target

        // Avoid infinite retry loop by checking if already retried
        if (!imgEl.dataset.retried) {
          imgEl.dataset.retried = 'true'

          // Clear and retry after a short delay
          const originalSrc = iconImageLink
          imgEl.src = '' // trigger reset
          setTimeout(() => {
            imgEl.src = originalSrc
          }, 300)
        } else {
          console.warn('Image failed after retry:', iconImageLink)
        }
      }
    },
    created () {
      let gender = Vue.ls.get('tss_landingCategory')
      this.activeNav = gender
      let activeNavData = this.sideNavData.find(item => item.name.toLowerCase() === gender || item.url_key === this.$route.path || item.url_key === `/${gender}`)
      this.selectNavMenu(activeNavData)
    }
  }
  </script>
  
  <style scoped>
  .tss-highlight {
    color: white !important;
    font-weight: 600 !important;
    
  }
  .sidenav {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    background-color: white;
    z-index: 1050;
    overflow-x: hidden;
    transition: 0.3s ease;
    transform: translateX(-100%);
    /* padding: 1rem; */
    box-shadow: 2px 0 5px rgba(0,0,0,0.3);
  }

  .header-container {
    box-shadow: 0px 4px 4px 0px #DCE9EA;
  }
  
  /* Open state */
  .sidenav.open {
    transform: translateX(0);
  }
  
  /* Overlay behind sidenav */
  .sidenav-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,0.4);
    z-index: 1049;
  }

  .brand-info {
    width: 100%;
    padding: 1rem;
  }

  .brand-info-exclusives {
    background: #282d3f;
    margin-top: -5px;

    .user-info {
      .user {
        .user-name {
          color: #FFFFFF;
        }
      }
    }
  }

  .user-info {
    width: 100%;
    position: relative;
    margin: 0px 10px 10px 15px;
  }

  .user {
    margin-top: 8px;
  }

  .user-name {
    width: 350px;
    color: #0A0404;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */
    letter-spacing: 0.5px;
    text-transform: capitalize;
  }

  .user-email {
    color: rgba(10, 4, 4, 0.80);
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 10px; /* 133.333% */
    letter-spacing: 0.5px;
  }

  .user-exclusive-member {
    color: #e76a52;
    font-family: Lato;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 10px; /* 133.333% */
    padding-bottom: 8px;
    letter-spacing: 0.5px;
    width: 100%;
    margin-bottom: 1px; /* Pushes the next element below the border */
    position: relative;
  }

  .user-exclusive-member::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(to left, transparent, #e76a52);
  }

  .non-exclusive-member {
    color: #18A7A8;
    font-family: Lato;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 10px; /* 133.333% */
    padding-bottom: 8px;
    letter-spacing: 0.5px;
    width: 100%;
    margin-bottom: 1px; /* Pushes the next element below the border */
    position: relative;
  }

  .non-exclusive-member::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(to left, transparent, #18A7A8);
  }

  .exclusive-description {
    color: #FFFFFF;
    font-size: 14px;
    font-family: Lato;
    span {
      color: #e76a52;
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; /* 125% */
      letter-spacing: 0.5px;
      text-transform: capitalize;
    }
  }
  

  .login-block {
    margin-left: 20px;
    border-radius: 6px;
    border: 1px solid #158B8D;
    width: 200px;
    display: flex;
    padding: 15px 11px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;

    span {
      color: #0A0404;
      font-family: 'Source Sans Pro', sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; /* 125% */
      letter-spacing: 0.5px;
      text-transform: capitalize;
    }
  }

  .nav-menu-container {
    display: flex;
    justify-content: space-evenly;
    margin-top: 20px;
  }

  .nav-menu-item span {
    color: #8A8A8A;
    font-family: Montserrat;
    font-size: 17px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.333px;
  }

  .hover-tag-name:hover .heading-wraper {
    color: #c01d1d;
  }

  .activeCat {
    color: #148C8D !important;
    font-weight: 700 !important;
    /* border-bottom: 2px solid;
    padding: 3px 7px; */
  }

  .location-change-style {
    margin: 1px;
    align-self: start;
  }
  .guest-location-style{
    margin: 4px;
  }

  .list-container {
    padding: 1rem;
  }

  .carousel-block {
    width: 90.656px;
    height: 113.887px;
    flex-shrink: 0;
    border-radius: 9.077px;
    background: #F4F4F4;
  }

  .carousel-img {
    width: 91px;
    max-height: 90px;
    border-radius: 9.077px;
  }

  .carousel-text {
    padding: 5px;
    color: #181818;
    text-align: center;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 12.17px;
    font-style: normal;
    font-weight: 600;
    line-height: 16.136px; /* 158.667% */
  }

  .cat-list-dropdown {

    span {
      color: #292b2c;
      font-family: 'Source Sans Pro', sans-serif;
      font-size: 17px;
      font-style: normal;
      font-weight: 600;
      line-height: 32px; /* 200% */
      letter-spacing: 0.08px;
    }
  }

  .category-dropdown {
    border-bottom: 1px dashed #E5E5E5;
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .cat-dropdown {
    
    span {
      color: #282d3f;
      font-family: 'Source Sans Pro', sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 16.227px; /* 115.906% */
      letter-spacing: 0.451px;
    }
  }

  .category-list {
    margin: 0;
    border-radius: none;
    border: none;
    width: 100%;
    box-shadow: none
  }

  .arrowImg {
    width: 22px;
    height: 22px;
    transform: rotate(90deg);
    cursor: pointer;
  }
  .arrow-up {
    transform: rotate(-90deg);
  }

  .img-fade {
    filter: grayscale(100%);
    opacity: 0.6;
  }

  .sub-cat-icon {
    img {
      width: 75px;
      height: 75px;
      border-radius: 8px;
    }
  }

  .sub-cat-large-icon {
    img {
      width: 78px;
      height: 100px;
      border-radius: 4px;
    }
  }

  .sub-cat-name {
    margin-top: 5px;
    max-width: 78px;
    word-wrap: break-word;
    color: #292b2c;
    text-align: center;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .cat-icon-continer {
    margin: 5px;
  }

  .sub-category-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
    gap: 0.5rem;
    width: 100%;
  }

  .has-small-icon {
    grid-template-columns: repeat(auto-fill, minmax(84px, 1fr));
  }

  .brand-logo img {
    width: 80px;
    /* height: 45.6px; */
    max-width: none;
  }

  .heading-wraper {
    position: relative;
  }

  .tag-name {
    /* font-size: 10px;
    color: red;
    font-weight: bold;
    display: block;
    text-align: end;
    margin-bottom: -13px;
    margin-right: -30px; */
    position: absolute;
    top: -8px;
    right: -10px;
    font-weight: bold;
    /* background-color: red; */
    color: #cd1515;
    padding: 2px 6px;
    font-size: 10px;
    border-radius: 50px;
    z-index: 2;
  }

  .singal-tag-name {
    position: absolute;
    margin-top: 2px;
    font-weight: bold;
    color: #cd1515;
    padding: 2px 4px;
    font-size: 10px;
    border-radius: 50px;
    z-index: 2;
  }

  .mb-30 {
    /* margin-bottom: -30px; */
    margin-right: -20px
  }

  .icon-wrapper {
    position: relative;
    display: inline-block; /* or block, depending on layout */
  }

  .large-icon-tag,
  .small-icon-tag {
    position: absolute;
    top: -8px;
    right: -10px;
    background-color: red; /* or any color you want */
    color: white;
    padding: 2px 6px;
    font-size: 10px;
    border-radius: 50px;
    z-index: 2;
  }


  .notify-user {
    margin-top: -15px;
    display: flex;
    height: 42px;
    padding: 9px 29px 10px 31px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border-radius: 0px 0px 16px 16px;
    background: #148C8D;
    color: #FFFFFF !important;

    span {
      color: #FFFFFF !important;
      text-align: center;
      font-family: Source Sans Pro;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }

  .notify-user-exclusives {
    /* background: linear-gradient(113deg, #F4E9FD 0%, #D8C0E9 23.19%, #D6F1FE 45.76%, #F2F1FE 66.73%, #F8DEF4 88.38%); */
    background: #148C8D;
    span {
      color: whitesmoke;
    }
  }

  .store-icon {
    margin-left: 0.8rem;
    width: 24px;
    height: 24px;
    border: 1px solid #18A7A8;
    border-radius: 5px;
    box-shadow: #0B0B0B 0px 1px 2px 0px;
  }

  .store-icon:hover { 
    width: 25px;
    height: 25px;
  }

  .padding-py3 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  
  /* Responsive Width */
  @media (max-width: 768px) {
    .sidenav {
      width: 90%;
    }
    .brand-info {
      width: 100%;
    }

    .user {
      margin-top: 0;
    }

    .padding-py3 {
      padding-top: 0.70rem;
      padding-bottom: 0.70rem;
    }

    .user-name {
      width: 250px;
      font-size: 15px;
      line-height: 10px !important;
    }
    .user-email {
      font-size: 12px;
      line-height: 0;
    }
    .member-link {
      margin-top: 10px;
    }
    .user-exclusive-member {
      font-size: 12px !important;
      line-height: 0;
    }
    .non-exclusive-member {
      font-size: 12px !important;
      line-height: 0;
    }
    .exclusive-description {
      font-size: 12px;
    }
    .exclusive-description span {
      font-size: 12px;
    }
    .login-block {
      margin-left: 10px;
      width: 170px;
    }
    .nav-menu-item span {
      font-size: 15px;
    }
    .carousel-block {
      width: 78.656px;
      height: 103.887px;
    }
    .carousel-text {
      font-size: 10.17px;
    }

    .cat-list-dropdown {
      span {
        font-size: 15px;
        font-weight: 600;
        line-height: 16px;
        letter-spacing: 0.08px;
      }
    }

    .cat-dropdown {
      span {
        font-size: 14px;
      }
    }

    .sub-cat-large-icon {
      img {
        width: 78px !important;
        height: 100px !important;
        border-radius: 4px;
      }
    }

    .sub-cat-name-w {
      max-width: 60px !important;
    }
    .cat-icon-continer {
      /* margin: 14px; */
    }

    .sub-cat-icon {
      img {
        width: 60px;
        height: 60px;
        border-radius: 8px;
      }
    }
    .sub-category-list {
      gap: 0;
    }
    .brand-logo img {
      width: 65px;
      height: 45.6px;
      max-width: none;
    }
    .mb-30 {
      margin-bottom: -10px;
      margin-right: -25px
    }

    .notify-user {
      height: 36px;
      span {
        font-size: 12px;
      }
    }
    .sub-cat-name-w {
      max-width: 60px !important;
    }

    .carousel-img {
      width: 88px;
      max-height: 80px;
      border-radius: 9.077px;
    }
    
  }

  @media (min-width: 769px) {
    .sidenav {
      width: 40%;
    }
  }
  @media (max-width: 990px) {
    .sidenav {
      width: 90% !important;
    }
    .sub-cat-name-w {
      max-width: 75px;
    }
  }
  @media (max-width: 1080px) {
    .sidenav {
      width: 45%;
    }
    .sub-cat-name-w {
      max-width: 75px; 
    }
  }
  @media (max-width: 400px) {
    .has-small-icon {
      grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));
    }
    .sidenav {
      width: 90% !important;
    }
    .store-icon {
      width: 13px;
      height: 13px;
    }
  }
  @media (min-width: 991px) {
  .sidenav::-webkit-scrollbar {
    width: 2px;
  }

  .sidenav::-webkit-scrollbar-track {
    background: transparent;
  }

  .sidenav::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }

  .sidenav {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
  }
}
  </style>



// WEBPACK FOOTER //
// sideNav.vue?49b9c56e